module.exports = __webpack_public_path__ + "img/troll.a910efcb.svg";